const goUrl = url => {
  window.location.href = url
}

export {
  goUrl
}
